import { common_controller } from "@/api/commonService";

export default {
    data() {
        return {
            //研究领域  创业导师
            industryArr: [],
            // 创业导师职称类型
            professionalTitleArr: [],

            //基地类型
            baseTypeArr: [],
            //基地等级
            baseGradeArr: [],
            // 所属行业  科研招聘
            projecttypeArr: [],
            // 单位类型  科研招聘
            businessscopeArr: [],
            // 产业智库  智库类型
            thinktanktypeArr: [],
            // 找人才  招聘类型
            releaseTypeArr: [],
            // 科技成果   成果类型
            achievementClassifyArr: [],
            // 科技成果   成果所属技术领域
            technoSphereArr: [],
            // 科技成果   技术成熟度
            techMaturityArr: [],

            // 科技成果   项目需求
            projectDemandArr: [],
            // 科技成果  需求分类
            trTypeArr: []

        }
    },
    methods: {
        //获取字典表数据
        getDist(type) {
            this.getAction({
                url: common_controller.getDictDataByGroupNumber,
                params: { groupNumbers: type }
            }).then((res) => {
                if (type == 'research_field') {//研究领域
                    this.industryArr = res
                }
                if (type == 'professionalTitle') {//创业导师职称类型
                    this.professionalTitleArr = res
                }
                if (type == 'base_type') {//基地类型
                    this.baseTypeArr = res
                }
                if (type == 'base_grade') {//基地等级
                    this.baseGradeArr = res
                }
                if (type == 'projecttype') {// 所属行业  科研招聘
                    this.projecttypeArr = res
                }
                if (type == 'businessscope') {//单位类型  科研招聘
                    this.businessscopeArr = res
                }
                if (type == 'thinktank_type') {
                    this.thinktanktypeArr = res
                }
                if (type == 'recruitment_methods') {
                    this.releaseTypeArr = res
                }
                if(type == 'belong_techField'){
                    this.technoSphereArr = res
                }
                if(type == 'technical_maturity'){
                    this.techMaturityArr = res
                }
                if(type == 'result_type'){
                    this.achievementClassifyArr = res
                }
                if(type == 'project_demand'){
                    this.projectDemandArr = res
                }
                if(type == 'demand_type'){
                    this.trTypeArr = res
                }
            })
        },
    }
}
